import { ChangeSocial } from './ChangeSocial';

export class ChangeGoogle extends ChangeSocial {
  type: string = 'ChangeGoogle';
}
